import {
    useMutation,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import longTermLeasePositionRequests from 'app/requests/LongTermLeasePosition/LongTermLeasePosition.requsts'
import simpleApi from 'app/services/simpleApi'

type Params = {
    onSuccess: () => void,
}

const DOMAIN_NAME = 'LongTermLeasePosition'

const useArchiveLongTermLeasePosition = ({
    onSuccess,
}: Params) => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessArchive,
        onError,
    } = useHandleStatusRequest({
        id: DOMAIN_NAME,
        title: 'Long Term Lease Position Archived',
        onSuccess,
    })

    return useMutation({
        mutationFn: ({
            longTermLeasePositionId,
        }: {longTermLeasePositionId: number}) => {
            return simpleApi({
                ...longTermLeasePositionRequests.archive({
                    longTermLeasePositionId,
                }),
                token,
            })
        },
        onSuccess: onSuccessArchive,
        onError,
    })
}

export default useArchiveLongTermLeasePosition
